import styles from "./Header.module.css";

function Header() {
	return (
		<div className={styles.header}>
			<img src="/assets/images/unhcr_logo.png" alt="Profile" />
		</div>
	);
}

export default Header;
